import { useTranslation } from 'react-i18next';
import { useUpdateEffect } from 'react-use';

import { ModalHeader } from '@/components/Modal';
import { Modal } from '@/components/Modal/Modal2';
import {
  selectActiveTab,
  selectNomenclatureStoreSelectedRow,
  selectVariant,
  useNomenclatureStore,
  useNomenclatureStoreActions,
  useNomenclatureStoreContextWindowsState,
} from '@/components/nomenclature/useNomenclatureStore';

import { ExpertDataForm } from './ExpertData';
import { ImagesForm } from './Images';
import { InstructionForPharmacistTab } from './InstructionForPharmacist';
import { InstructionTab } from './InstructionTab/InstructionTab';
import { LinksForm } from './Links';
import { NomenclatureForm } from './NomenclatureForm';
import { NomenclatureModalTabbar } from './NomenclatureModalTabbar';
import { ReceptionFeaturesForm } from './ReceptionFeatures/ReceptionFeaturesForm';

// ----------------------------------------------------------------------

export const NomenclatureCreateModal = () => {
  const { t } = useTranslation('nomenclature-page');
  const { isCreateModalVisible } = useNomenclatureStoreContextWindowsState();
  const { closeCreateModal, setPreferredTab, resetSelectedRow, setActiveTab, setVariant } =
    useNomenclatureStoreActions();

  const activeTab = useNomenclatureStore(selectActiveTab);
  const variant = useNomenclatureStore(selectVariant);

  const drug = useNomenclatureStore(selectNomenclatureStoreSelectedRow);

  useUpdateEffect(() => {
    if (isCreateModalVisible) {
      setVariant('create');
    }
  }, [isCreateModalVisible]);

  const handleClose = () => {
    closeCreateModal();
    setPreferredTab('general');
    setActiveTab('general');
    resetSelectedRow();
    // TODO - resetGalleryStore();
    // resetGalleryStore();
  };

  if (!variant) {
    return null;
  }

  return (
    <Modal open={isCreateModalVisible} onClose={handleClose}>
      <ModalHeader
        title={[t('modals.create.breadcrumb.root'), t('modals.create.breadcrumb.action')]}
        onClose={handleClose}
      />

      <NomenclatureModalTabbar variant="create" />

      {activeTab === 'general' && <NomenclatureForm variant={variant} drug={drug} onClose={handleClose} />}

      {activeTab === 'additionalCodesAndLinks' && <LinksForm variant={variant} drug={drug} onClose={handleClose} />}

      {activeTab === 'instruction' && drug && <InstructionTab variant={variant} drug={drug} onClose={handleClose} />}

      {activeTab === 'expertData' && <ExpertDataForm variant={variant} drug={drug} onClose={handleClose} />}

      {activeTab === 'receptionFeatures' && (
        <ReceptionFeaturesForm variant={variant} drug={drug} onClose={handleClose} />
      )}

      {activeTab === 'images' && drug && <ImagesForm variant={variant} drug={drug} onClose={handleClose} />}

      {activeTab === 'instructionForPharmacist' && drug && (
        <InstructionForPharmacistTab variant={variant} drug={drug} onClose={handleClose} />
      )}
    </Modal>
  );
};
